export default __webpack_public_path__ + "static/media/UPS-main.9849f4e8.svg";